function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M28.3 255.1V28.3h63.8v78h92.1v28.3h28.3V92.1L106.3 0H0v283.5h64v-28.3l-35.7-.1zm92.2-205.3L153 78h-32.5V49.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.2 156v127.4h198.3V156H85.2zm139.1 28.5l-40 23.5-40.2-23.5h80.2zM113.7 255v-55.2l70.7 41.3 70.6-41.5V255H113.7z"
})));